<template>
  <div class="custom-phone-input">
    <label v-if="isLabel" :for="id" class="control-box__label">{{ $t('auth_phone_label') }}</label>
    <TheMask
      name="phone"
      :id="id"
      :value="value"
      @input="$emit('input', $event)"
      type="tel"
      :masked="false"
      :disabled="disableFields"
      mask="+38 (0##) ### ## ##"
      :placeholder="placeholder"
      class="control control--phone-auth control--input control-box__control"
      ref="phone"
      :autocomplete="autocomplete"
      @blur.native="$emit('blur')"
    ></TheMask>
  </div>
</template>

<script>
import { TheMask } from 'vue-the-mask'

export default {
  name: 'PhoneInput',
  components: { TheMask },
  props: {
    disableFields: Boolean,
    value: String,
    id: String,
    isLabel: Boolean,
    placeholder: {
      type: String,
      default: '+38 (0__) ___ __ __'
    },
    autocomplete: {
      type: String,
      default: 'tel'
    }
  }
}
</script>

<style scoped></style>
